import { render } from "./AppCharacterField.vue?vue&type=template&id=0f29ce06"
const script = {}

import "./AppCharacterField.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script